import SearchEmptyIcon from '@/assets/icons/search-empty.svg?react';
import cn from 'classnames';

interface EmptyPlaceholderProps {
  description?: string;
  className?: string;
}
export const EmptyPlaceholder = ({ description, className }: EmptyPlaceholderProps) => {
  return (
    <div className={cn('inline-flex flex-col justify-center items-center w-full', className)}>
      <SearchEmptyIcon />
      <p className="self-stretch text-[color:var(--500-fill--,#737373)] text-center [font-family:Geist] text-sm font-normal leading-[150%] tracking-[0.07px]">
        {description}
      </p>
    </div>
  );
};
